import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingPane, SaveButton, ModalWindow, asyncOperationUtilities, accessibilityNotificationsEmitter } from '../../common';
import { SiteList } from './site-list-folder';
import { TouchpointList } from './touchpoint-list-folder';
import { toastr } from 'react-redux-toastr';

export class TouchpointPermissionsComponent extends Component {

  componentDidUpdate(prevProps, prevState) {
    const { siteListProps : prevSiteProps } = prevProps;
    const { selectedSiteId : prevSelectedSiteId } = prevSiteProps || {};
    const { siteListProps } = this.props;
    const { selectedSiteId } = siteListProps || {};
    if(selectedSiteId && !prevSelectedSiteId) {
      var modalFocusTarget = document.getElementById('modal-content');
      if(modalFocusTarget) modalFocusTarget.focus();
    }
    else if(!selectedSiteId && prevSelectedSiteId) {
      var viewFocusTarget = document.getElementById('view');
      if(viewFocusTarget) viewFocusTarget.focus();
    }
  }

  handleUpdate(siteId) {
    const { siteListProps } = this.props;
    const { changeSelectedSite } = siteListProps || {};
    accessibilityNotificationsEmitter.assertive("touchpoint permissions modal opened");
    changeSelectedSite(siteId);
  }

  handleClose() {
    const { siteListProps } = this.props;
    const { changeSelectedSite } = siteListProps || {};
    changeSelectedSite(null);
  }

  onSaveComplete() {
    const { siteListProps } = this.props;
    const { changeSelectedSite } = siteListProps || {};

    toastr.success('Success', 'the touchpoint permissions have been saved!');
    changeSelectedSite(null);
  }

  onSaveFail(errors) {
    var message = '';
    errors && errors.forEach(err => {
      message += (err.errorMessage + '\n')
    });
    toastr.error("Save Failed", message);
  }

  handleSave() {
    const { siteListProps, touchpointListProps } = this.props;
    const { permissionProps, submitSettings } = touchpointListProps || {};
    const { submitTouchpointPermissions } = permissionProps || {};
    const { selectedSiteId } = siteListProps || {};

    asyncOperationUtilities.handleAsyncCalls([
      () => submitSettings(selectedSiteId),
      () => submitTouchpointPermissions(selectedSiteId)
    ]).then(results => this.onSaveComplete(), results => this.onSaveFail(results.errors));
  }

  render() {
    const { siteListProps, touchpointListProps } = this.props;
    const { selectedSiteId, sites, changeSelectedSite } = siteListProps || {};
    const { isFetching : formsLoading, err : formErr, permissionProps } = touchpointListProps || { isFetching: false };
    const { submission } = permissionProps || {};
    const { isSubmitting } = submission || {};

    const selectedSite = sites && sites.results && sites.results.find(site => site.id === selectedSiteId);
    const siteName = selectedSite && selectedSite.name;
    const touchpointIds = selectedSite && selectedSite.touchpointFormIds;

    return (
      <div>
        <SiteList {...siteListProps} onUpdate={siteId => this.handleUpdate(siteId)} isLoading={siteListProps.isFetching} loadingMessage={'Loading sites'} />
        <ModalWindow
          show={!!selectedSiteId}
          onClose={e => this.handleClose()}
          title="TouchPoint Permissions"
          footer={(
            <div className="actions">
              <button id="close" className="btn btn-default" onClick={e => changeSelectedSite(null)}>
                Cancel
              </button>
              <SaveButton
                id="save"
                text={"Save and Close"}
                saving={isSubmitting}
                onSave={e => this.handleSave()}/>
            </div>
          )}>
          <LoadingPane id="form-loader" isLoading={formsLoading} err={formErr}>
            <TouchpointList {...touchpointListProps} siteName={siteName} siteId={selectedSiteId} touchpointIds={touchpointIds}/>
          </LoadingPane>
        </ModalWindow>
      </div>
    );
  }
}

TouchpointPermissionsComponent.propTypes = {
  siteListProps : PropTypes.shape({
    isFetching: PropTypes.bool,
    err: PropTypes.any,
    sites: PropTypes.object,
    selectedSiteId: PropTypes.string,
    sortBy: PropTypes.string,
    sortAsc: PropTypes.bool,
    resultsPerPage: PropTypes.number,
    changeSort: PropTypes.func,
    changePageNumber: PropTypes.func,
    changeSelectedSite: PropTypes.func,
  }),
  touchpointListProps : PropTypes.shape({
    isFetching: PropTypes.bool,
    err: PropTypes.any,
    forms: PropTypes.object,
    allForms: PropTypes.object,
    formsEditData: PropTypes.object,
    sortBy: PropTypes.string,
    sortAsc: PropTypes.bool,
    resultsPerPage: PropTypes.number,
    changeSort: PropTypes.func,
    changePageNumber: PropTypes.func,
    showFormDetails: PropTypes.func,
    programData: PropTypes.object,
    programListActions: PropTypes.any,
    permissionProps: PropTypes.shape({
      permissions: PropTypes.object,
      submission: PropTypes.object,
      responses: PropTypes.object,
      fetchTouchpointPermissions: PropTypes.func,
    })
  })

};

export default TouchpointPermissionsComponent;
